/**
 * PianoRollWrapper Component
 * Wrapper for Piano Roll modal with MIDI editing
 */

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import PianoRoll from '../PianoRoll';

export const PianoRollWrapper = ({
  isOpen,
  editingClip,
  editingTrackId,
  tracks,
  bpm,
  timeSignature,
  isPlaying,
  currentTime,
  onClipUpdate,
  onClose,
  synthRef,
  drumSynthRef,
  DRUM_KIT,
  undo,
  redo,
  canUndo,
  canRedo,
}) => {
  return (
    <AnimatePresence>
      {isOpen && editingClip && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex flex-col bg-zinc-950"
          data-testid="piano-roll-modal"
        >
          <PianoRoll
            clip={editingClip}
            onClipUpdate={onClipUpdate}
            onClose={onClose}
            bpm={bpm}
            timeSignature={timeSignature}
            isPlaying={isPlaying}
            currentTime={currentTime}
            onPlayNote={(note, velocity) => {
              const track = tracks.find(t => t.id === editingTrackId);
              if (track?.instrumentType === 'drums') {
                // Find drum name from note
                const drumEntry = Object.entries(DRUM_KIT).find(([_, d]) => d.note === note);
                if (drumEntry) {
                  drumSynthRef?.current?.playDrum(drumEntry[0], velocity);
                }
              } else {
                synthRef?.current?.noteOn(note, velocity);
              }
            }}
            onStopNote={(note) => {
              const track = tracks.find(t => t.id === editingTrackId);
              if (track?.instrumentType !== 'drums') {
                synthRef?.current?.noteOff(note);
              }
            }}
            onUndo={undo}
            onRedo={redo}
            canUndo={canUndo}
            canRedo={canRedo}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PianoRollWrapper;
